import React from 'react';

import LoadingSpinner from '../../components/LoadingSpinner';
import { useTitleBasic } from '../../libs/useTitle';

interface LoadingProps {
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = (props) => {
  useTitleBasic('Loading...');

  return <div className={`flex bg-background text-foreground ${props.fullScreen === true ? 'h-screen' : '-h-screen-nav'}`}>
      <div className='flex flex-col mx-auto my-auto'>
        <LoadingSpinner className='mx-auto w-32 h-32' />
        <div className='text-center h2 pt-2'>Loading...</div>
      </div>

  </div>;
};

export default Loading;
